import { QuestResponseType } from '../AccountsPayable/AccountsPayable.types';

export enum QuestAccountsReceivableFilterDateBy {
  emission,
  dueDate,
  payment,
}

export enum QuestAccountsReceivableReportType {
  emission,
  dueDate,
  receipt,
  planAccount,
  planAccountSynthetic,
  payment,
}

export enum QuestAccountsReceivableOrderBy {
  date,
  description,
  debtor,
  code,
  planAccount,
  documentType,
}

export interface QuestAccountsReceivableRequest {
  responseType: QuestResponseType;
  companiesIds?: string;
  situationOpen: boolean;
  situationSettled: boolean;
  filterDateBy: QuestAccountsReceivableFilterDateBy;
  reportType: QuestAccountsReceivableReportType;
  orderBy: QuestAccountsReceivableOrderBy;
  insurerIds?: string;
  documentTypeIds?: string;
  costCenterIds?: string;
  accountsPlanIds?: string;
  bankAccountIds?: string;
  customerIds?: string;
  startDate: string;
  endDate: string;
}

export const REPORT_ACCOUNTS_RECEIVABLE_FILTER_DATE_BY_FORMAT = {
  EMISSION: QuestAccountsReceivableFilterDateBy.emission,
  DUE: QuestAccountsReceivableFilterDateBy.dueDate,
  PAY: QuestAccountsReceivableFilterDateBy.payment,
};

export const REPORT_ACCOUNTS_RECEIVABLE_REPORT_TYPE = {
  EMISSION: QuestAccountsReceivableReportType.emission,
  DUE: QuestAccountsReceivableReportType.dueDate,
  PAY: QuestAccountsReceivableReportType.payment,
  PLAN_ACCOUNT: QuestAccountsReceivableReportType.planAccount,
  PLAN_ACCOUNT_SYNTHETIC:
    QuestAccountsReceivableReportType.planAccountSynthetic,
};

export const REPORT_ACCOUNTS_RECEIVABLE_ORDER_BY = {
  DATE: QuestAccountsReceivableOrderBy.date,
  DESCRIPTION: QuestAccountsReceivableOrderBy.description,
  DEBTOR: QuestAccountsReceivableOrderBy.debtor,
  CODE: QuestAccountsReceivableOrderBy.code,
  PLAN_ACCOUNT: QuestAccountsReceivableOrderBy.planAccount,
  DOCUMENT_TYPE: QuestAccountsReceivableOrderBy.documentType,
};
